import React from 'react';

// Example: Keeping images in public/images folder
const themes = [
  { id: 1, img: '/id1.png', label: 'Theme1' },
  { id: 2, img: '/id2.png', label: 'Theme2' },
  { id: 3, img: '/id3.png', label: 'Theme3' },
  { id: 4, img: '/id4.png', label: 'Theme4' },
 
];

const ThemeSelector = ({ selectedThemeId, onThemeChange }) => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '70vh',
      gap: 40,
      marginTop: 80,
    }}
  >
    {themes.map(theme => (
      <div
        key={theme.id}
        onClick={() => onThemeChange(theme.id)}
        tabIndex={0}
        style={{
          cursor: 'pointer',
          outline: selectedThemeId === theme.id ? '3px solid #0078d7' : '2px solid #ccc',
          borderRadius: 16,
          background: selectedThemeId === theme.id ? '#e6f0fa' : '#fff',
          boxShadow: selectedThemeId === theme.id ? '0 4px 32px #b6d8f8aa' : '0 2px 10px #00000017',
          width: 260,
          height: 200,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'outline 0.2s, box-shadow 0.2s, background 0.2s',
        }}
      >
        <img
          src={theme.img}
          alt={`Preview for ${theme.label}`}
          style={{
            width: 220,
            height: 120,
            objectFit: 'cover',
            borderRadius: 12,
            marginBottom: 18,
            boxShadow:
              selectedThemeId === theme.id ? '0 0 12px #90caf9' : '0 1px 6px #bbb'
          }}
        />
        <div
          style={{
            fontSize: 22,
            fontWeight: 600,
            color: selectedThemeId === theme.id ? '#0078d7' : '#222',
            letterSpacing: 1,
          }}
        >
          {theme.label}
        </div>
      </div>
    ))}
  </div>
);

export default ThemeSelector;
